'kiwi public';

import _asyncToGenerator from "@babel/runtime-corejs3/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _ from 'lodash';
var StatePersistence = /*#__PURE__*/function () {
  function StatePersistence(storageKey, state, storage, logger) {
    _classCallCheck(this, StatePersistence);
    this.storageKey = storageKey;
    this.state = state;
    this.storage = storage;
    this.logger = logger;
    this.isPersisting = false;
    this.includeBuffers = true;
    this.watcher = null;
    this.state.persistence = this;
  }
  return _createClass(StatePersistence, [{
    key: "loadStateIfExists",
    value: function () {
      var _loadStateIfExists = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var storedState;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.storageKey) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              _context.next = 2;
              return this.storage.get(this.storageKey);
            case 2:
              storedState = _context.sent;
              if (storedState) {
                if (this.logger) {
                  this.logger('Importing state', storedState);
                }
                this.state.importState(storedState);
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadStateIfExists() {
        return _loadStateIfExists.apply(this, arguments);
      }
      return loadStateIfExists;
    }()
  }, {
    key: "stopWatchingState",
    value: function stopWatchingState() {
      if (this.watcher) {
        this.watcher();
        this.watcher = null;
      }
    }
  }, {
    key: "watchStateForChanges",
    value: function watchStateForChanges() {
      var _this = this;
      if (!this.storageKey) {
        return;
      }

      // Throttle saving the state into storage so we don't thrash the disk
      var debouncedSaveState = _.debounce(function () {
        if (_this.logger) {
          _this.logger('State updated, setting localStorage');
        }
        _this.storage.set(_this.storageKey, _this.state.exportState(_this.includeBuffers));
      }, 1000);
      this.state.$watch('networks', debouncedSaveState, {
        deep: true
      });
      this.state.$watch('user_settings', debouncedSaveState, {
        deep: true
      });

      // We need to touch each property of each buffer for that we want to save our state on.
      // If any of the properties change then the $watch()er will call debouncedSaveState()
      this.watcher = this.state.$watch(function () {
        var watchVals = [];
        _this.state.networks.forEach(function (network) {
          var _context2;
          var buffersVals = [];
          buffersVals.push(_mapInstanceProperty(_context2 = network.buffers).call(_context2, function (b) {
            return b.name;
          }).join(','));
          network.buffers.forEach(function (buffer) {
            buffersVals.push([buffer.name, buffer.settings, buffer.joined, buffer.enabled, buffer.last_read]);
          });
          watchVals.push(buffersVals);
        });
        return _JSON$stringify(watchVals);
      }, debouncedSaveState);
      this.isPersisting = true;
    }
  }, {
    key: "forgetState",
    value: function () {
      var _forgetState = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.state.resetState();
              _context3.next = 1;
              return this.storage.set(this.storageKey, null);
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee2, this);
      }));
      function forgetState() {
        return _forgetState.apply(this, arguments);
      }
      return forgetState;
    }()
  }]);
}();
export { StatePersistence as default };
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["StatePersistence"]
window._kiwi_exports.libs.StatePersistence = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
